import React, {useCallback} from 'react'
import PropTypes from 'prop-types'
import {ButtonPrimary} from '@modifi/ui'
import {useAbility} from '../../../../constants/permissions'
import {TRANSACTION} from '../../../../constants/section'

const FooterSubmitButton = ({pending, completed, onClick, closeDialog}) => {
  const ability = useAbility()
  const isAllowed = ability.can('match', TRANSACTION)
  const handleClick = useCallback(
    e => {
      e && e.preventDefault()
      return !pending && !completed ? onClick() : closeDialog()
    },
    [onClick, pending, completed, closeDialog]
  )

  return (
    <ButtonPrimary onClick={handleClick} active={!pending && isAllowed}>
      {!pending && !completed ? 'Confirm' : 'Close'}
    </ButtonPrimary>
  )
}

FooterSubmitButton.propTypes = {
  pending: PropTypes.bool.isRequired,
  completed: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default FooterSubmitButton
